import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosServices from 'utils/axios';
import Alert from '@mui/material/Alert';
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';
import { Accordion, AccordionDetails, AccordionSummary, InputLabel, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CopyIcon from '../../../../assets/images/promotion/icon_copy.svg';
import './index.less';
import toast from 'react-hot-toast';

const KeyFormDialog = (props: { open: boolean; handleClose: () => void }) => {
    const theme = useTheme();
    const { open, handleClose } = props;
    const { locale } = useConfig();
    const { updateProfile, cdkeys } = useAuth();

    const [key, setKey] = React.useState('');
    const [useList, setUseListy] = React.useState<any[]>([]);
    const [keyList, setKeyList] = React.useState<any[]>([]);
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    console.log('matchDownMd', matchDownMd);
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState(false);
    const [awaitAata, setAwaitAata] = React.useState<any>('');
    const handleChangeKey = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | undefined) => {
        if (error) {
            setError('');
        }
        event?.target.value && setKey(event?.target.value);
    };
    const handleConfrim = async () => {
        try {
            const arr = key.split('#');
            if (arr.length === 2) {
                let lang = locale === 'zh' ? 'en' : 'zh';

                const { data } = await axiosServices.post(`/web/use_cdkey`, { key_data: arr.at(0), key_sec: arr.at(1), lang });

                if (data.status === 0) {
                    setAwaitAata(data);
                    setSuccess(true);
                } else {
                    setError(data.text);
                }
            } else {
                setError('CD Key 无效');
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleCopyCdky = (cdkey: string) => {
        // 检查浏览器是否支持 Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            // 使用 Clipboard API 进行复制
            navigator.clipboard
                .writeText(cdkey)
                .then(() => {
                    toast.success(`已复制CdKey至粘贴板`);
                    console.log('复制成功 (Clipboard API):', cdkey);
                    // 可以在这里给用户一个反馈，比如显示“复制成功”的提示
                })
                .catch((err) => {
                    console.error('复制失败 (Clipboard API):', err);
                    // 如果失败，可以尝试使用备选的 execCommand 方法
                    fallbackCopyTextToClipboard(cdkey);
                });
        } else {
            // 浏览器不支持 Clipboard API 时，使用备选方法
            console.warn('浏览器不支持 Clipboard API，使用 fallback 方法。');
            fallbackCopyTextToClipboard(cdkey);
        }
    };

    const fallbackCopyTextToClipboard = (textToCopy: string) => {
        let textArea;
        try {
            // 1. 创建一个临时的 textarea 元素
            textArea = document.createElement('textarea');
            textArea.value = textToCopy;

            // 设置样式使其不可见，但能被选中
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = '0';
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';

            // 2. 将其添加到文档中
            document.body.appendChild(textArea);

            // 3. 选中内容
            textArea.select();

            // 4. 执行复制命令
            const successful = document.execCommand('copy');

            if (successful) {
                toast.success(`已复制CdKey至粘贴板`);
                console.log('复制成功 (execCommand):', textToCopy);
            } else {
                console.error('复制失败 (execCommand): 浏览器拒绝执行命令。');
                // 可以在这里提示用户手动复制
            }
        } catch (err) {
            console.error('复制失败 (execCommand):', err);
        } finally {
            // 5. 移除临时的 textarea
            if (textArea) {
                document.body.removeChild(textArea);
            }
        }
    };
    const handleCloseDialog = async () => {
        if (success) {
            updateProfile();
        }
        setError('');
        setSuccess(false);
        handleClose();
    };

    React.useEffect(() => {
        if (cdkeys) {
            const keys: any[] = [];
            const uses: any[] = [];
            cdkeys?.forEach((item: any) => {
                if (item.state === 0) {
                    keys.push(item);
                } else {
                    uses.push(item);
                }
            });
            setUseListy(uses);
            setKeyList(keys);
        }
    }, [cdkeys]);

    console.log(keyList);
    return (
        <Dialog open={open} sx={{ p: 0 }} onClose={handleCloseDialog}>
            <DialogTitle sx={{ p: 0, pl: 3, fontSize: 21 }}>
                {success ? <FormattedMessage id="cdkey.dialog.success-title" /> : <FormattedMessage id="cdkey.dialog.title" />}
            </DialogTitle>
            {success ? (
                <>
                    <DialogContent sx={{ width: '100%', mt: 2 }}>
                        <Alert severity="success">
                            <FormattedMessage id="cdkey.dialog.success-con" values={{ days: awaitAata.days, quota: awaitAata.quota }} />
                        </Alert>
                    </DialogContent>
                    <DialogActions sx={{ pr: 3 }}>
                        <Button variant="contained" onClick={handleCloseDialog}>
                            <FormattedMessage id="cdkey.dialog.close" />
                        </Button>
                    </DialogActions>
                </>
            ) : (
                <>
                    <DialogContent sx={{ width: '100%' }}>
                        <DialogContentText sx={{ marginTop: 1, fontSize: 18 }}>
                            <FormattedMessage id="cdkey.dialog.content" />
                            <Link
                                component="button"
                                onClick={() => {
                                    window.open('https://x.com/xiaodiqiuyi');
                                }}
                                underline="none"
                            >
                                <FormattedMessage id="cdkey.dialog.link" />
                            </Link>
                            <FormattedMessage id="cdkey.dialog.end" />
                        </DialogContentText>
                        {error && <Alert severity="error">{error}</Alert>}
                        <InputLabel sx={{ marginTop: 1, fontSize: 18 }} shrink htmlFor="bootstrap-input">
                            CD Key
                        </InputLabel>
                        <TextField
                            onChange={handleChangeKey}
                            placeholder="XXXXX-XXXXX-XXXXX-XXXXX#XXXXX"
                            required
                            id="key"
                            name="key"
                            type="text"
                            fullWidth
                            focused
                        />
                        {cdkeys && cdkeys.length > 0 && (
                            <Accordion defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ padding: 0 }}>
                                    <Typography component="span">
                                        <FormattedMessage id="cdkey.dialog.list-title" />
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0, height: '301px', overflow: 'auto' }}>
                                    {keyList.map((item: any, index: number) => {
                                        return (
                                            <section key={item.key_data} className="cdkey-item">
                                                <section className="left-info">
                                                    <section className="label" style={{ fontSize: matchDownMd ? '9px' : '14px' }}>
                                                        [ {index + 1} ]
                                                    </section>
                                                    <section className="code" style={{ fontSize: matchDownMd ? '9px' : '20px' }}>
                                                        {item.key_data}#{item.key_sec}
                                                    </section>
                                                </section>
                                                <section
                                                    className="copy"
                                                    onClick={() => {
                                                        handleCopyCdky(item.key_data + '#' + item.key_sec);
                                                    }}
                                                >
                                                    <img alt="copy" width={'16px'} height={'16px'} src={CopyIcon} />
                                                </section>
                                            </section>
                                        );
                                    })}
                                    {useList.map((item: any, index: number) => {
                                        return (
                                            <section key={item.key_data} className="cdkey-item">
                                                <section className="left-info use">
                                                    <section
                                                        className="label"
                                                        style={{ color: '#E9E9E980', fontSize: matchDownMd ? '9px' : '14px' }}
                                                    >
                                                        [<FormattedMessage id="cdkey.dialog.list-use" />]
                                                    </section>
                                                    <section
                                                        className="code"
                                                        style={{ color: '#E9E9E980', fontSize: matchDownMd ? '9px' : '20px' }}
                                                    >
                                                        {item.key_data}#{item.key_sec}
                                                    </section>
                                                </section>
                                            </section>
                                        );
                                    })}
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ pr: 3 }}>
                        <Button color="error" variant="contained" onClick={handleCloseDialog}>
                            <FormattedMessage id="cdkey.dialog.cancel" />
                        </Button>
                        <Button variant="contained" onClick={handleConfrim}>
                            <FormattedMessage id="cdkey.dialog.confirm" />
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};
export default KeyFormDialog;
